import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylish%20modern%20shopping%20scene%20with%20premium%20sneakers%20luxury%20watch%20designer%20sunglasses%20and%20leather%20bag%20arranged%20on%20white%20marble%20countertop%20with%20fresh%20green%20monstera%20plant%20leaves%20soft%20golden%20morning%20light%20streaming%20through%20window%20creating%20warm%20shadows%20elegant%20European%20boutique%20aesthetic%20editorial%20fashion%20photography%20with%20sophisticated%20composition%20and%20refined%20neutral%20palette&width=1800&height=900&seq=kakobuy-hero-v2-2026&orientation=landscape"
          alt="Kakobuy Spreadsheet produkty"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 pt-20">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
            {t('hero.title')}
          </h1>
          <p className="text-base md:text-lg text-background-100/90 max-w-2xl mx-auto mb-8 leading-relaxed">
            {t('hero.subtitle')}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              <span>{t('hero.cta1')}</span>
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 font-semibold text-sm hover:bg-background-50/30 transition-all cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              <span>{t('hero.cta2')}</span>
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-primary-400 w-5 h-5 flex items-center justify-center"></i>
              <span className="text-sm text-background-100/90 whitespace-nowrap">{t('hero.stat1')}</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-primary-400 w-5 h-5 flex items-center justify-center"></i>
              <span className="text-sm text-background-100/90 whitespace-nowrap">{t('hero.stat2')}</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-primary-400 w-5 h-5 flex items-center justify-center"></i>
              <span className="text-sm text-background-100/90 whitespace-nowrap">{t('hero.stat3')}</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-primary-400 w-5 h-5 flex items-center justify-center"></i>
              <span className="text-sm text-background-100/90 whitespace-nowrap">{t('hero.stat4')}</span>
            </div>
          </div>

          {/* Article Link */}
          <div className="mt-10">
            <Link
              to="/artykul/kakobuy-sheet-kompletny-przewodnik"
              className="inline-flex items-center gap-2 text-sm text-background-100/80 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap underline underline-offset-4"
            >
              <i className="ri-article-line w-4 h-4 flex items-center justify-center"></i>
              <span>Kompletny przewodnik Kakobuy Sheet 2026</span>
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}